export enum ContentSubject {
  all = -1,
  reading,
  lectura,
  math,
  matematicas,
}
